"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTACT_INFO_BOX = void 0;
exports.CONTACT_INFO_BOX = 'ContactInfoBox';
//# sourceMappingURL=constants.js.map